import {useTranslation} from '@aboutyou/i18n';
import {useInitialUtmParams, useIsCheckoutPage} from '@aboutyou/router';
import {
  ConsentServices,
  useIsConsentBannerClosed,
  useIsGA4ConsentGiven,
  useIsStorageConsentGiven,
  useIsTradedoublerConsentGiven,
} from '@aboutyou/storage';
import {
  Button,
  ContentPopper,
  ContentPopperProps,
} from '@aboutyou/ui-components';
import React, {useState} from 'react';
import {TradedoublerConsentBody} from './TradedoublerConsentBody';

export const TradedoublerConsent: React.FC<{
  LayoutComponent: ContentPopperProps['LayoutComponent'];
}> = ({LayoutComponent}) => {
  const utmParams = useInitialUtmParams();
  const isTradedoublerConsentGiven = useIsTradedoublerConsentGiven();
  const isStorageConsentGiven = useIsStorageConsentGiven();
  const isGoogleAnalyticsConsentGiven = useIsGA4ConsentGiven();
  const isConsentClosed = useIsConsentBannerClosed();
  const isCheckout = useIsCheckoutPage();
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  const onConsentClicked = () => {
    if (window.UC_UI) {
      window
        .UC_UI!.acceptServices(
          [
            ConsentServices.Tradedoubler,
            ConsentServices.Storage,
            ConsentServices.GA4,
          ],
          'explicit',
        )
        .then(() => {
          window.__ucCmp!.saveConsents();
        });

      window.bt.evt.push({
        event: 'consent',
        eventData: {
          location: 'customBanner',
          action: 'accept',
          feature: 'Payback',
        },
      });
    }
    // we could wait for consent to be updated but this is quicker
    setIsOpen(false);
  };

  const onCloseClicked = () => {
    window.bt.evt.push({
      event: 'consent',
      eventData: {
        location: 'customBanner',
        action: 'cancel',
        feature: 'Payback',
      },
    });
    setIsOpen(false);
  };

  if (
    (!isTradedoublerConsentGiven ||
      !isStorageConsentGiven ||
      !isGoogleAnalyticsConsentGiven) &&
    utmParams.has('pb') &&
    utmParams.get('pb') === '1' &&
    isConsentClosed &&
    !isCheckout
  ) {
    return (
      <ContentPopper
        LayoutComponent={LayoutComponent}
        headerContent={t('Payback consent')}
        open={isOpen}
        bodyContent={<TradedoublerConsentBody />}
        footerContent={
          <>
            <Button variant="secondary" onClick={onCloseClicked}>
              {t('Cancel')}
            </Button>
            <Button variant="primary" onClick={onConsentClicked}>
              {t('Consent')}
            </Button>
          </>
        }
        onClose={() => {
          window.bt.evt.push({
            event: 'consent',
            eventData: {
              location: 'customBanner',
              action: 'close',
              feature: 'Payback',
            },
          });

          setIsOpen(false);
        }}
      />
    );
  }

  return null;
};
